import React from 'react';
import Typewriter from 'typewriter-effect';
import { useSpring, animated } from 'react-spring';
import { useInView } from 'react-intersection-observer';
import { useState, useEffect } from 'react';

export default function Home(props) {
  const [hasFadedIn, setHasFadedIn] = useState(false);
  const { ref, inView } = useInView({
    threshold: 0
  });

  const contentProps = useSpring({
    opacity: hasFadedIn ? 1 : 0,
    from: { opacity: 0 },
    config: { duration: 1200 },
  });

  useEffect(() => {
    if (inView && !hasFadedIn) {
      setHasFadedIn(true);
    }
  }, [inView, hasFadedIn]);


  return (
    <div id='home' className='-z-50 w-full h-screen bg-cover bg-no-repeat bg-center bg-fixed bg-gray-500 bg-opacity-50 filter grayscale-' style={{ backgroundImage: 'url(bgimage4.png)' }} onMouseOver={() => props.onHover("home")}>
        <div ref={ref} className='flex flex-col items-center justify-center h-screen relative bottom-8'>
        <animated.div  className='text-3xl text-white relative bottom-8 md:bottom-0' style={contentProps}>
            <div className='text-3xl text-white font-bold md:text-[70px] md:relative md:bottom-3 md:right-12' >Prathmesh Nikam</div> 
            <div className='flex flex-wrap font-semibold md:mt-6 md:relative md:bottom-3 md:right-12'>I'm&nbsp;
            <Typewriter
            
      options={{
        strings: ['a Competitive Programmer', ' an Engineer', ' a Tech Enthusiastic', ' an Aspiring Software Engineer', 'Coder', 'Developer'],
        autoStart: true,
        loop: true,
        wrapperClassName: "text-white p-1 border-b-[3px] border-blue-400"
      }}
    />
            </div> 
        </animated.div>
        </div>
    </div>
  )
}
